<template>
    <div>
      <el-row class="mb-20">
        <el-col :span="24">
          <el-table
            :data="registrations"

            style="width: 100%"
            stripe
            :row-class-name="getClassnameById"
            class="item-table hidden-sm-and-down"
          >

            <el-table-column
              label="Image"
              width="100"
            >
            <template slot-scope="scope">
                <img :src="getImage(scope.row)" width="50" height="50" />
              </template>
            </el-table-column>
            <el-table-column
              label="Item"
              width="200"
              sortable
            >
                <template slot-scope="scope">
                <div class="break-word" >{{scope.row.saleableItem.name}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="entityType"
              label="Purchased From"
              min-width="250"
              sortable
            >
            <template slot-scope="scope">
              <div class="break-word" >   {{ getPurchasedFrom(scope.row) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              label="Price"
              width="100"
              sortable
            >
              <template slot-scope="scope">
                  {{ priceFormatter(scope.row.saleableItem.price) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="size"
              label="Size"
              min-width="100"
              sortable
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.size }}
              </template>
            </el-table-column>
            <el-table-column
              prop="qty"
              label="Quantity"
              min-width="100"
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.qty }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="Date Purchased"
              min-width="200"
              sortable
            >
            <template slot-scope="scope">
                  {{ dateFormatter(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="" width="70" align="center" fixed="right">
              <template slot-scope="scope">
                <el-tooltip  placement="top">
                  <div slot="content">
                    <span > Download Receipt</span>
                  </div>
                  <span>
                    <el-button size="small" type="danger" @click="downloadReceipt(scope.row)" >
                      <i class="el-icon-download"></i>
                    </el-button>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <el-table
            :data="registrations"
            border
            stripe
            class="item-table hidden-md-and-up"
          >
          <el-table-column
              label="Image"
              width="100"
            >
            <template slot-scope="scope">
                <img :src="getImage(scope.row)" width="50" height="50" />
              </template>
            </el-table-column>
          <el-table-column
              label="Item"
              width="200"
              sortable
            >
                <template slot-scope="scope">
                <div class="break-word" >{{scope.row.saleableItem.name}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="entityType"
              label="Purchased From"
              min-width="250"
              sortable
            >
            <template slot-scope="scope">
              <div class="break-word" >   {{ getPurchasedFrom(scope.row) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              label="Price"
              width="100"
              sortable
            >
              <template slot-scope="scope">
                  {{ priceFormatter(scope.row.saleableItem.price) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="size"
              label="Size"
              min-width="100"
              sortable
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.size }}
              </template>
            </el-table-column>
            <el-table-column
              prop="qty"
              label="Quantity"
              min-width="100"
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.qty }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="Date Purchased"
              min-width="200"
              sortable
            >
            <template slot-scope="scope">
                  {{ dateFormatter(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="Operations" width="190">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="downloadReceipt(scope.row)">
                  Download Receipt
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </template>

<script>
import _, { startCase } from 'lodash';
import moment from 'moment-timezone';
import { calculateMemberAge } from '@/utils/helpers';
import { mapGetters } from 'vuex';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { clientNationalIds } from '@/utils/client-rules';
import { fileUploadAcceptString, resultTypes } from '../../../utils/constants';

export default {
  components: { },
  props: {
    value: Object,
  },
  data() {
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      key: 0,
      capitalize: _.capitalize,
      registrations: [],
      membershipToRegister: {},
      fileUploadAcceptString,
      get: _.get,
      showQsDialog: false,
      dialogValue: {
        filtersVisible: false,
        entityType: undefined,
        registration: undefined,
        regoDetails: undefined,
      },
    };
  },
  mounted() {
    const { regoId, regoProductId } = this.$route.params;
    if (this.value._id) {
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/portal/registrations/members/${this.value._id}/purchase-items`)
        .then((res) => {
          this.registrations = _.map(res.data.data, (data) => ({ ...data, results: _.get(data, 'results.0', {}) }));
          this.registrations = this.registrations.map((rego) => _.assign(rego, { upgradingDropdown: false }));
          // eslint-disable-next-line no-restricted-syntax
          for (const membership of this.registrations) {
            if (_.get(membership, 'regoEntity.products') && membership.regoEntity.products.upgradeableMembershipList && membership.expired !== true) {
              // eslint-disable-next-line no-restricted-syntax
              for (const um of membership.regoEntity.products.upgradeableMembershipList) {
                if (um._id === regoId) {
                  const foundProduct = um.products.find((product) => product._id === regoProductId);
                  if (foundProduct) {
                    setTimeout(() => {
                      // eslint-disable-next-line prefer-destructuring
                      const position = (document.getElementsByClassName(`${membership._id}`))[0];
                      position.scrollIntoView({ behavior: 'smooth' });
                    }, 200);
                  }
                }
              }
            }
          }
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e);
          this.$store.commit('loading', false);
        });
    }
  },
  methods: {
    getImage(row) {
      if (_.get(row, 'saleableItem.images[0].url')) {
        return _.get(row, 'saleableItem.images[0].url');
      }
      return this.logo;
    },
    getPurchasedFrom(item) {
      console.log('item', item);
      if (item.entityType === 'membership') {
        return item.membership[0].name;
      } if (item.entityType === 'event') {
        return item.event[0].name;
      }
      return '';
    },
    closeDialog() {
      this.dialogValue = {
        filtersVisible: false,
      };
    },
    updateMeta({ meta, regoId }) {
      const foundIndex = this.registrations.findIndex((rego) => rego._id === regoId);
      if (foundIndex >= 0) this.registrations[foundIndex].meta = meta;
    },
    updateFiles({ files, regoId }) {
      const foundIndex = this.registrations.findIndex((rego) => rego._id === regoId);
      if (foundIndex >= 0) this.registrations[foundIndex].files = files;
    },
    makePayment(rego) {
      // push to route partial payment
      console.log('make payment', rego);
      this.$router.push({ name: 'partial-payment', params: { id: rego._id } });
    },
    priceFormatter(value) {
      return `$${value / 100}`;
    },
    async deregisterRequest(row) {
      const confirm = await this.$confirm('By clicking yes a request will be sent to the administrator to confirm the deregistration and issue a refund.', {
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
      });

      if (confirm) {
        await this.$http.post('/assemble/api/v1/portal/deregistration-status/registration/request', {
          registrationId: row._id
        });
        // eslint-disable-next-line no-param-reassign
        const index = this.registrations.findIndex((rego) => rego._id === row._id);
        this.$set(this.registrations[index], 'deregistrationRequest', [{ status: 'pending' }]);

        this.$message.success('Request Sent!');

        this.$store.commit('loading', false);
      }
    },
    isShowableAnswer(name, questions) {
      const flattenQuestions = [];
      _.forEach((questions), (q) => {
        if (q.fieldName) {
          flattenQuestions.push({ type: q.type, question: q.question, fieldName: _.camelCase(q.fieldName) });
        }
        if (q.parentsDependentQsList && q.parentsDependentQsList.length) {
          _.forEach(q.parentsDependentQsList[0].children, (cq) => {
            flattenQuestions.push({ type: cq.type, question: cq.question, fieldName: _.camelCase(cq.fieldName) });
          });
        }
      });
      const question = _.find(flattenQuestions, (q) => (q.fieldName && q.fieldName === name));
      if (!question) return false;
      if (![1, 2].includes(question.type)) return false;
      return true;
    },
    isUpgradeEligible(rego) {
      if (rego.entityType === 'membership' && _.get(rego, 'regoEntity.products.isUpgradeable') && !rego.upgradingDropdown && !rego.expired) {
        const { dob, gender } = this.value.profile;
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(dob, endOfYear);
        const membershipList = rego.regoEntity.products.upgradeableMembershipList;
        const checkEligible = membershipList.some((membership) => membership.products.some((product) => age >= product.ageFrom && age <= product.ageTo && (product.gender === gender || product.gender === 'All' || (product.gender === 'Other' && (gender !== 'Male' || gender !== 'Female')))));
        return checkEligible;
      }
      return false;
    },
    getFilterdMemberships(upgradeableMembershipList) {
      const { dob, gender } = this.value.profile;
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      const list = _.cloneDeep(upgradeableMembershipList);
      list.forEach((membership) => {
        // eslint-disable-next-line no-param-reassign
        membership.products = membership.products.filter((product) => age >= product.ageFrom && age <= product.ageTo && (product.gender === gender || product.gender === 'All' || (product.gender === 'Other' && (gender !== 'Male' || gender !== 'Female'))));
      });
      return list;
    },
    async downloadReceipt(registration) {
      let charges = [];
      try {
        const response = await this.$http.get(`/assemble/api/v1/portal/registrations/${registration._id}/receipt`);
        charges = response.data.data;
      } catch {
        this.$message.error('An error occured while downloading receipt');
      }

      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      if (!charges.length) this.$message.success('This registration did not incur any cost thus no receipt was found');

      let logo = '';
      let isURL = false;
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        logo = process.env.VUE_APP_LOGO;
        isURL = true;
      }

      const dd = await this.$http.post('/assemble/api/v1/portal/registrations/receipt-content', {
        member: this.value, charges, logo, isURL, type: 'member'
      });

      if (!isURL) {
        dd.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
        dd.data.data.images = { logo: await this.getBase64Logo() };
      }

      console.log(dd);

      pdfMake.createPdf(dd.data.data).download(`${registration._id}-${dd.data.chargeId}.pdf`);
    },

    getResultLabel: (type) => _.find(resultTypes, { type }).label,
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    onError(error) {
      if (error.message) {
        const json = JSON.parse(error.message);
        this.$message.error(json.message || 'There has been an error');
      } else {
        this.$message.error('There has been an error');
      }
    },
    entityFormatter(row) {
      if (!row.fromImport) {
        if (row.team && row.team.name) return `${row.team.name} - ${_.get(row, 'regoEntity.name')}`;
        return _.get(row, 'regoEntity.name');
      }
      return row.meta.productName || '';
    },
    dateFormatter(timestamp) {
      return moment(timestamp).tz(this.timezone).format('DD MMM YYYY, HH:mm');
    },
    handleChangeMem(rego) {
      const registrations = this.$store.getters['cart/registrations'];
      const [id, productId] = _.get(rego, 'regoEntity.membershipToUpgrade');
      const memberId = this.value._id;
      this.$confirm('Are you sure you want to upgrade this membership?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then(() => {
          this.$store.commit('loading', true);
          this.$http.post(`/assemble/api/v1/portal/registrations/search/entities/${id}/products/${productId}`)
            .then((res) => {
              const { result, transactionFee } = res.data.data;
              const [resutObject] = result;
              // eslint-disable-next-line no-param-reassign
              this.membershipToRegister = resutObject;
              const { _id: entityId, productType, memberType } = this.membershipToRegister;

              const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                  && r.memberId === memberId
                                  && r.productType === productType
                                  && r.memberType === memberType);
              if (foundRego) this.$message.error('Registration for this member has already been added to cart.');
              else {
                this.$store.commit('cart/setTransactionFee', transactionFee);
                // eslint-disable-next-line no-param-reassign
                delete rego.upgradingDropdown;
                this.$router.push({
                  name: 'membership-register-individual',
                  params: { memberId, selectedMembership: this.membershipToRegister, upgradeFromMembership: rego },
                });
              }
              this.$store.commit('loading', false);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        })
        .catch(() => {});
    },
    async handleChange(file, fileList, config) {
      const fileIndex = fileList.findIndex((fl) => fl.name === file.name);
      try {
        this.$store.commit('loading', true);
        const res = await this.$http.post('/assemble/api/v1/portal/files/presigned-url', { fileName: file.name });
        const { url, name } = res.data.data;
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });
        const nameOnly = name.split('.')[0];
        const fileTypeOnly = name.split('.')[name.split('.').length - 1];
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].name = nameOnly;
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].type = fileTypeOnly;
        this.$store.commit('loading', false);
      } catch (e) {
        this.$message.error('There has been an error');
      }
      this.$store.commit('loading', true);

      // After uploading via s3 presigned url, update file-uploads collection
      this.$http.post(this.fileUpdateUrl, {
        originalName: file.raw.name.split('.')[0],
        fileName: file.name,
        fileType: file.type,
        ...config
      }).then((res) => {
        const { fileId, fileName } = res.data.data;
        this.$message.success('File uploaded successfully');
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex]._id = fileId;
        // eslint-disable-next-line no-param-reassign
        fileList[fileIndex].name = `${fileName} Uploaded At: ${this.dateFormatter(this.moment())}`;
      }).catch((e) => {
        console.log(e);
        this.$message.error('There has been an error uploading the file');
      }).finally(() => {
        this.$store.commit('loading', false);
      });
    },
    removeFile(file) {
      const fileId = file._id;
      if (fileId) {
        return this.$confirm('You are about to permanently delete this file. Are you sure you want to continue?', 'Warning', { type: 'warning' })
          .then(() => {
            this.$store.commit('loading', true);
            this.$http.delete(`/assemble/api/v1/portal/files/${fileId}`)
              .then(() => {
                this.$message.success('Success!');
                this.$store.commit('loading', false);
              })
              .catch(() => {
                this.$message.error('Error deleting file');
                this.$store.commit('loading', false);
              });
          })
          .catch();
      } if (file) {
        // Catch for when the file hasn't been uploaded yet
        return true;
      }
      return false;
    },
    getUploadExpiry(rego) {
      const { entityType } = rego;
      if (entityType === 'event') {
        const [event] = rego.event;
        const { regoEndDate, isActive } = event;
        if (moment().valueOf() <= regoEndDate && isActive) return false;
        return true;
      }
      return false;
    },
    getUploadTip(rego, field) {
      const question = rego.additionalQs.find((q) => q.fieldName === field);
      return question
        ? question.question
        : 'Uploaded files must be 10mb or less';
    },
    submitUpload(ref) {
      this.$store.commit('loading', true);
      const uploadComponent = this.$refs[ref][0];
      uploadComponent.submit();
    },
    previewUpload(file) {
      const { _id } = file;
      this.$http.get(`/assemble/api/v1/portal/files/${_id}/signed`)
        .then((res) => {
          window.open(res.data.url, '_blank');
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    groupedUploads(data) {
      const grouped = _.groupBy(data, (file) => file.meta.additionalQuestion);
      const out = Object.keys(grouped).map((group) => ([group, grouped[group]]));
      return out;
    },
    isNotExpired(rego) {
      const { entityType } = rego;
      if (+this.moment() <= rego[entityType][0].regoEndDate && rego[entityType][0].isActive) {
        return true;
      }
      return false;
    },
    handleDropdown(rego, val) {
      if (val === 'open') {
        // eslint-disable-next-line no-param-reassign
        rego.upgradingDropdown = true;
      } else {
        // eslint-disable-next-line no-param-reassign
        rego.upgradingDropdown = false;
      }
      this.key++;
    },
    getClassnameById({ row }) {
      return `${row._id}`;
    },
    joinTag(vals) {
      return vals ? _.join(_.map(vals, (v) => v.name), ', ') : '';
    },
    getQuestion(metaName, additionalQs) {
      const flattenQuestions = [];
      _.forEach((additionalQs), (q) => {
        if (q.fieldName) {
          flattenQuestions.push({ question: q.question, fieldName: _.camelCase(q.fieldName) });
        }
        if (q.parentsDependentQsList && q.parentsDependentQsList.length) {
          _.forEach(q.parentsDependentQsList[0].children, (cq) => {
            flattenQuestions.push({ question: cq.question, fieldName: _.camelCase(cq.fieldName) });
          });
        }
      });
      const aQ = flattenQuestions.find((data) => data.fieldName === metaName);
      return _.get(aQ, 'question');
    },
    metaFormat(value) {
      if (value && _.isArray(value)) return _.join(value, ', ');
      return value;
    },
    getBase64Logo() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ this.logo }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
  },
  computed: {
    latestDialogValue() {
      return this.dialogValue;
    },
    clubPlaceholder() {
      return process.env.VUE_APP_LOGO_ACCOUNT;
    },
    userId() {
      return this.$store.getters['user/userId'];
    },
    logo() {
      // eslint-disable-next-line global-require
      const logo = process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '' ? process.env.VUE_APP_LOGO : require('@/assets/logos/Assemble_Logo_RGB_Positive.png');
      // eslint-disable-next-line global-require
      const logoMark = process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Positive.png');
      return logo || logoMark;
    },
    customMemberDetailForm() {
      const nationalId = _.includes(clientNationalIds, +process.env.VUE_APP_NATIONAL_ID) ? process.env.VUE_APP_NATIONAL_ID : 0;
      // eslint-disable-next-line
        return () => import('@/views/app/clients/' + nationalId + '-member-profile-extras.vue');
    },
    accept() {
      return fileUploadAcceptString;
    },

    isNSWISA() {
      return +process.env.VUE_APP_NATIONAL_ID === 1;
    },
    memberIdLabel() {
      return +process.env.VUE_APP_NATIONAL_ID === 1 ? 'NSWISA Member ID' : 'Member ID';
    },
    fileUpdateUrl() {
      return `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/registration`;
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
  },
  filters: {
    startCase,
    cap(value) {
      return _.capitalize(value);
    },
    formatDate(date) {
      return moment(date).tz(this.timezone).format('DD MMM YYYY, HH:mm');
    },
  }
};
</script>

  <style lang="scss" scoped>
  ::v-deep .item-table {
    border: 1px solid rgba(45, 58, 69, 0.1);

    th {
      background: #f6f8fa !important;
      padding-right: 1em;
      text-align: left;
    }

    td {
      background-color: white !important;
      padding-top: 2em;
      text-align: left;
    }
  }

  ::v-deep .el-table__expanded-cell{
    padding-left:20px;
  }

  </style>
